// Thư mục: src/stores/xeStore.js
import { defineStore } from "pinia";
import { XeApi } from "@/services/xeService";
import { DmLoaiXeApi } from "@/services/dmLoaiXeService";

export const useXeStore = defineStore("xe", {
  state: () => ({
    isLoading: false,
    error: null,
    items: [], // Danh sách Xe (phân trang)

    // Paging state
    q: "",
    page: 0,
    size: 10,
    sort: "id,desc",
    totalPages: 1,
    totalElements: 0,

    // --- STATE MỚI ---
    // Danh sách Loại Xe cho dropdown
    loaiXeOptions: [],
    isLoadingOptions: false,
  }),

  getters: {
    currentPage(state) {
      return state.page + 1;
    },
  },

  actions: {
    // ... (setQuery, setPage, setSize giữ nguyên) ...
    setQuery(q) {
      this.q = q;
      this.page = 0;
    },
    setPage(p1) {
      const p0 = Math.max(0, p1 - 1);
      if (p0 !== this.page) this.page = p0;
    },
    setSize(s) {
      this.size = s;
      this.page = 0;
    },

    async fetchList() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = await XeApi.list({
          q: this.q,
          page: this.page,
          size: this.size,
          sort: this.sort,
        });
        // items bây giờ chứa XeDto (có loaiXeId, tenLoaiXe)
        this.items = data.content || [];
        this.totalPages = data.totalPages ?? 1;
        this.totalElements = data.totalElements ?? this.items.length;
        this.page = data.number ?? 0;
        this.size = data.size ?? this.size;
      } catch (e) {
        this.error =
          e?.response?.data?.message || e?.message || "Lỗi tải danh sách xe";
      } finally {
        this.isLoading = false;
      }
    },

    // --- ACTION MỚI ---
    // Gọi API /api/dm-loai-xe/active-options
    async fetchLoaiXeOptions() {
      if (this.loaiXeOptions.length > 0) return; // Chỉ load 1 lần

      this.isLoadingOptions = true;
      try {
        // Gọi hàm mới trong DmLoaiXeApi
        const data = await DmLoaiXeApi.listActiveOptions();
        this.loaiXeOptions = data || [];
      } catch (e) {
        console.error("Lỗi tải danh sách loại xe:", e);
        // Có thể set error riêng cho options
      } finally {
        this.isLoadingOptions = false;
      }
    },

    // Action CRUD (nhận XeRequestDto)
    async createXe(form) {
      await XeApi.create(form);
      await this.fetchList();
    },
    async updateXe(id, form) {
      await XeApi.update(id, form);
      await this.fetchList();
    },
    async deleteXe(id) {
      await XeApi.remove(id);
      if (this.items.length === 1 && this.page > 0) this.page -= 1;
      await this.fetchList();
    },
  },
});
